import { endpoints } from "../config";
import { getData } from "./api-utils";

const getVideoList = async () => {
  return await getData(endpoints.video);
};

export { getVideoList };
